import { render, staticRenderFns } from "./PracticeMultiselect.vue?vue&type=template&id=b746298c&scoped=true&"
import script from "./PracticeMultiselect.vue?vue&type=script&lang=js&"
export * from "./PracticeMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./PracticeMultiselect.vue?vue&type=style&index=0&id=b746298c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b746298c",
  null
  
)

export default component.exports